const blockBackNavigation = new Set([
    /* Landing onboarding */
    '/landing/onboarding',
    '/landing/onboarding/app',
    '/landing/onboarding/home',
    '/landing/onboarding/control',
    /* Home onboarding */
    '/home/welcome',
    '/home/welcome/device',
    '/home/welcome/service',
    '/home/welcome/play',
    /* Home tabs */
    '/home/devices',
    '/home/groups',
    /* Root url */
    '/',
    '/landing',
    '/home',
    '/services',
    '/play',
    '/devices',
    '/profile',
]);
const isBackNavigationAllowed = (pathname) => {
    return !blockBackNavigation.has(pathname);
};
const onBeforeRoutingEvent = (event) => {
    const singleSpaEvent = event;
    const { newUrl } = singleSpaEvent.detail;
    const { pathname } = new URL(newUrl);
    const canNavigateBack = isBackNavigationAllowed(pathname);
    window.bifrostNative?.setCanNavigateBack?.(canNavigateBack);
};
if (window.bifrostNative?.capabilities.includes('backNavigation')) {
    window.addEventListener('single-spa:before-routing-event', onBeforeRoutingEvent);
}
export const onDialogClose = () => {
    const { pathname } = window.location;
    const canNavigateBack = isBackNavigationAllowed(pathname);
    window.bifrostNative?.setCanNavigateBack?.(canNavigateBack);
};
